import type { CanActivateFn, Routes } from '@angular/router';
import { inject } from '@angular/core';
import { MsalGuard } from '@azure/msal-angular';
import { environment } from '../environments/environment';
import { isInTeams } from './services/teams/teams-runtime';

/**
 * Route guard that adapts to the runtime host:
 *  - mock mode: always allow.
 *  - Teams: allow (silent Teams SSO + teamsAuthInterceptor handle tokens on
 *    demand; the MSAL redirect cannot run inside the Teams iframe).
 *  - browser: delegate to MsalGuard (redirect flow).
 */
const authGuard: CanActivateFn = (route, state) => {
  if (environment.mockMode || isInTeams()) return true;
  return inject(MsalGuard).canActivate(route, state);
};

export const routes: Routes = [
  {
    path: 'auth-callback',
    loadComponent: () =>
      import('./pages/auth-callback/auth-callback.component').then(
        (m) => m.AuthCallbackComponent
      ),
    title: 'Signing in...',
  },
  {
    path: 'login-failed',
    loadComponent: () =>
      import('./pages/login-failed/login-failed.component').then(
        (m) => m.LoginFailedComponent
      ),
    title: 'Login Failed - ABM WorkAssist',
  },
  {
    path: '',
    loadComponent: () =>
      import('./pages/home/home.component').then((m) => m.HomeComponent),
    canActivate: [authGuard],
    title: 'ABM WorkAssist - Home',
  },
  {
    path: 'users',
    loadComponent: () =>
      import('./components/users/users.component').then((m) => m.UsersComponent),
    canActivate: [authGuard],
    title: 'Manage User Access - ABM WorkAssist',
  },
  {
    path: 'logged-out',
    loadComponent: () =>
      import('./pages/logged-out/logged-out.component').then(
        (m) => m.LoggedOutComponent
      ),
    title: 'Signed Out - ABM WorkAssist',
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
